class FlatPickr{
    constructor(el) {
        this.scope = el;
        this.isRange = el.hasAttribute("data-range");
        this.hasTime = el.hasAttribute("data-time");
        this.hasButtons = el.hasAttribute("data-buttons");
        this.createDatePicker();
    }

    createDatePicker(){
        const hiddenInput = this.scope.dataset.hiddenId ? document.getElementById(this.scope.dataset.hiddenId) : null; 
        flatpickr(this.scope, {
            mode: this.isRange ? "range" : "single",
            locale: {
                firstDayOfWeek: 1
            },
            showMonths: 1,
            showDaysInNextAndPreviousMonths: false,
            enableTime: this.hasTime,
            time_24hr: this.hasTime,
            disableMobile: true,
            onChange: (selectedDates) => {
                if (hiddenInput && selectedDates.length > 0) {
                    const d = selectedDates[0];
                    const formattedDate = d.toLocaleDateString("en-GB");
                    hiddenInput.value = formattedDate
                }
            },
            onReady: ( selectedDates, dateStr, instance) => {
                if(this.hasTime){
                    this.createTimeWrapper(instance);
                }
                if(this.hasButtons){
                    this.createFooterButtons(instance);
                }
            }
        });
    }

    createTimeWrapper(instance) {
        // If timeContainer doesn't exist yet, exit safely
        if (!instance || !instance.timeContainer) return;

        // Create Done button
        const btn = document.createElement("button");
        btn.type = "button";
        btn.textContent = "Done";
        btn.className = "button primary";

        btn.addEventListener("click", () => {
            instance.close();
        });

        instance.timeContainer.appendChild(btn);

        // Create label
        const customDiv = document.createElement("div");
        customDiv.className = "flatpickr-time-label label";
        customDiv.textContent = "Time";

        const parent = instance.timeContainer.parentNode;
        parent.insertBefore(customDiv, instance.timeContainer);
    }

    createFooterButtons(instance) {
        const calendar = instance.calendarContainer;

        // Prevent duplicate footer (important!)
        if (calendar.querySelector(".flatpickr-footer")) return;

        // Create footer wrapper
        const footer = document.createElement("div");
        footer.className = "flatpickr-footer";

        // Clear button
        const clearBtn = document.createElement("button");
        clearBtn.textContent = "Clear";
        clearBtn.type = "button";
        clearBtn.className =
            "button tertiary";
        clearBtn.addEventListener("click", () => {
            instance.clear();
        });

        // Done button
        const doneBtn = document.createElement("button");
        doneBtn.textContent = "Done";
        doneBtn.type = "button";
        doneBtn.className =
            "button primary";
        doneBtn.addEventListener("click", () => {
            instance.close();
        });

        footer.appendChild(clearBtn);
        footer.appendChild(doneBtn);

        calendar.appendChild(footer);
    }


}


document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(`[data-flatpickr]`).forEach(el => new FlatPickr(el));
});
if ('navigation' in window && typeof window.navigation.addEventListener === 'function') {
    window.navigation.addEventListener("navigate", () => {
        setTimeout(() => {
            document.querySelectorAll("[data-flatpickr]").forEach(el => {
                new FlatPickr(el);
            });
        }, 60);
    });
}